import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface GetSalesDeliveryDateResponse {
    oldest_delivery_date: string;
    latest_delivery_date: string;
}

export const useGetSalesDeliveryDate = ({ customerIdx, payment_status }: { customerIdx: number, payment_status?: number }): UseQueryResult<GetSalesDeliveryDateResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetSalesDeliveryDateResponse, Error>({
        queryKey: ["getSalesDeliveryDate", payment_status],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_sales_delivery_date.replace(":customer_idx", customerIdx.toString())}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    payment_status
                }
            });
            return response.data.data;
        },
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                };
            }
            return undefined;
        },
    });
};
